import { render, staticRenderFns } from "./app.vue?vue&type=template&id=466d78be&"
import script from "./app.component.ts?vue&type=script&lang=ts&"
export * from "./app.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\DadProj\\termin-verwaltung\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('466d78be')) {
      api.createRecord('466d78be', component.options)
    } else {
      api.reload('466d78be', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=466d78be&", function () {
      api.rerender('466d78be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/app.vue"
export default component.exports